<form>
    <app-form-section [formGroup]="detailsForm">
        <app-form-row-header [title]="'FEATURES.AGREEMENTS.GROUP_TITLE_PARTS' | translate" icon="domain" />
        <div class="form">
            <app-form-row>
                <app-form-group>
                    <label for="customerId"
                        >{{ 'FEATURES.AGREEMENTS.CUSTOMER' | translate }}
                        <app-pdf-reference-icon [fieldName]="agreementMetaDataConstants.CustomerName"
                    /></label>
                    <app-dropdown
                        [searchable]="true"
                        [items]="customers$ | async"
                        formControlName="customerId"
                        [highlightAnimated]="isFieldHighlighted(agreementMetaDataConstants.CustomerName)"
                        (highlightFocus)="onFieldFocus(agreementMetaDataConstants.CustomerName)"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.customerId"
                        languageKey="FEATURES.AGREEMENTS.CUSTOMER"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="responsibleId">{{ 'FEATURES.AGREEMENTS.RESPONSIBLE' | translate }}</label>
                    <app-dropdown [searchable]="true" [items]="users$ | async" formControlName="responsibleId" />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.responsibleId"
                        languageKey="FEATURES.AGREEMENTS.RESPONSIBLE"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="signer"
                        >{{ 'FEATURES.AGREEMENTS.SIGNER' | translate }}
                        <app-pdf-reference-icon [fieldName]="agreementMetaDataConstants.CustomerSigned"
                    /></label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="signer"
                        formControlName="signer"
                        type="text"
                        [ngClass]="{
                            'highlight-animated': isFieldHighlighted(agreementMetaDataConstants.CustomerSigned)
                        }"
                        (focus)="onFieldFocus(agreementMetaDataConstants.CustomerSigned)"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.signer"
                        languageKey="FEATURES.AGREEMENTS.SIGNER"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <label for="counterpartId"
                        >{{ 'FEATURES.AGREEMENTS.COUNTERPART' | translate }}
                        <app-pdf-reference-icon [fieldName]="agreementMetaDataConstants.CounterpartName"
                    /></label>
                    <div class="counterpart">
                        <app-dropdown
                            class="component"
                            [searchable]="true"
                            [items]="counterparts$ | async"
                            formControlName="counterpartId"
                            [highlightAnimated]="isFieldHighlighted(agreementMetaDataConstants.CounterpartName)"
                            (highlightFocus)="onFieldFocus(agreementMetaDataConstants.CounterpartName)"
                        />
                        <button (click)="createCounterpart()" *ngIf="!disabled" class="text">
                            <span class="material-symbols-rounded" aria-label="Add">add</span>
                        </button>
                        <button (click)="showPartsInfo = !showPartsInfo" class="mb-s2">
                            <span class="material-symbols-rounded" aria-label="Hide" *ngIf="showPartsInfo"
                                >keyboard_arrow_up</span
                            >
                            <span class="material-symbols-rounded" aria-label="Show" *ngIf="!showPartsInfo"
                                >keyboard_arrow_down</span
                            >
                            {{ 'FEATURES.AGREEMENTS.PARTS_DETAILS' | translate }}
                        </button>
                    </div>
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.counterpartId"
                        languageKey="FEATURES.AGREEMENTS.COUNTERPART"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <!-- <app-form-group> -->
                <ng-container *ngIf="showPartsInfo">
                    <app-create-and-update-counterpart
                        [counterpart]="selectedCounterpart"
                        [initialCompanyName]="initialCounterpartCompanyName"
                    ></app-create-and-update-counterpart>
                </ng-container>
                <!-- </app-form-group> -->
            </app-form-row>
            <!-- <app-form-row-header [title]="'FEATURES.AGREEMENTS.GROUP_TITLE_READERS' | translate" /> -->
            <p>{{ 'FEATURES.AGREEMENTS.GROUP_TITLE_READERS' | translate }}</p>
            <app-form-row>
                <app-form-group>
                    <div class="help-label">
                        <app-checkbox
                            [text]="'FEATURES.AGREEMENTS.ALLREADERS_ACCESS' | translate"
                            (ngModelChange)="toggleReaderAccess($event)"
                            formControlName="allReadersAccess"
                        />
                        <span
                            [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.READERS' | translate"
                            class="material-symbols-rounded"
                            aria-hidden="true"
                        >
                            help
                        </span>
                    </div>
                </app-form-group>
            </app-form-row>
            <app-form-row *ngIf="!f.allReadersAccess.value">
                <app-form-group>
                    <label for="readers">{{ 'FEATURES.AGREEMENTS.READERS' | translate }}</label>
                    <app-multi-select
                        [showToggleAll]="false"
                        [searchable]="true"
                        [showAllText]="false"
                        [items]="readers$ | async"
                        formControlName="readers"
                        [placeholder]="
                            'SELECT.SELECT_WITH_LABEL'
                                | translate
                                    : {
                                          label: 'FEATURES.AGREEMENTS.GROUP_TITLE_READERS' | translate
                                      }
                        "
                    />
                </app-form-group>
            </app-form-row>
        </div>
    </app-form-section>
</form>
